import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";

/**
 * References > Documentation. One page for every reference document: the route's data names the
 * page title and the Markdown file under /assets/docs.
 */
@Component({
  selector: "uni-reference-doc",
  standalone: false,
  templateUrl: "./reference-doc.component.html",
  encapsulation: ViewEncapsulation.None,
  host: { class: "flex flex-col flex-1 overflow-hidden" },
})
export class ReferenceDocComponent extends DomainBaseComponent {
  mdSrc: string;
  pageTitle: string;

  constructor(domainService: DomainService, route: ActivatedRoute) {
    super(domainService);
    this.mdSrc = route.snapshot.data["mdSrc"];
    this.pageTitle = "References: " + route.snapshot.data["breadcrumb"];
    this.isPageReady = true;
  }
}
